<template>
    <div class="warp">
        <a href="/" class="logo"><img src="../assets/home/logo (2).png"></a>
        <div class="navbar">
            <div class="navbar-item">
                <span v-if="language == 'zh'">关于我们 Brief</span>
                <span v-else>Brief</span>
                <div class="menuList">
                    <div class="left">
                        <div class="zh">关于我们</div>
                        <div class="en">About us</div>
                    </div>
                    <div class="aboutUs-right">
                        <div class="aboutUs-right-warp">
                            <div class="aboutUs-right-item">
                                <router-link tag="div" to="/companyProfile" class="title-warp">
                                    <div class="title-zh">企业介绍</div>
                                    <div class="title-en">Company Profile</div>
                                </router-link>
                                <router-link tag="div" to="/honorAndQualification" class="sub-warp">
                                    <div class="sub-title-zh">荣誉资质</div>
                                    <div class="sub-title-en">Qualifications & Honors</div>
                                </router-link>
                            </div>
                            <!-- <div class="aboutUs-right-item">
                                <router-link tag="div" to="/customerPartner" class="title-warp">
                                    <div class="title-zh">客户伙伴</div>
                                    <div class="title-en">Customer Partner</div>
                                </router-link>
                            </div> -->
                            <div class="aboutUs-right-item">
                                <router-link tag="div" to="" class="title-warp">
                                    <div class="title-zh">企业文化</div>
                                    <div class="title-en">Corporate Culture</div>
                                </router-link>
                                <router-link tag="div" to="/brandStory" class="sub-warp">
                                    <div class="sub-title-zh">品牌故事</div>
                                    <div class="sub-title-en">Brand Story</div>
                                </router-link>
                                <router-link tag="div" to="/developmentHistory" class="sub-warp">
                                    <div class="sub-title-zh">发展历程</div>
                                    <div class="sub-title-en">Enterprise History</div>
                                </router-link>
                            </div>
                            <div class="aboutUs-right-item">
                                <router-link tag="div" to="/linkUs" class="title-warp">
                                    <div class="title-zh">联系我们</div>
                                    <div class="title-en">Connect Us</div>
                                </router-link>
                            </div>
                        </div>
                        <div class="tip">用建筑科技守护生活！守护爱！</div>
                    </div>
                </div>
            </div>
            <div class="navbar-item">
                <span v-if="language == 'zh'">业务案例 Cases</span>
                <span v-else>Cases</span>
                <div class="menuList">
                    <div class="left">
                        <div class="zh">业务案例</div>
                        <div class="en">Cases</div>
                    </div>
                    <div class="anli-right">
                        <div class="anli-right-warp">
                            <div class="list-warp">
                                <div class="title-warp">
                                    <div class="title">核心业务</div>
                                    <div class="title-en">Core Business </div>
                                </div>
                                <div class="list-item">
                                    <router-link tag="div" to="Case?index=0" class="item">
                                        <div class="sub-title">门窗工程</div>
                                        <div class="sub-title-en">Doors & Windows</div>
                                        <img src="" alt="">
                                    </router-link>
                                    <router-link tag="div" to="Case?index=1" class="item">
                                        <div class="sub-title">幕墙工程</div>
                                        <div class="sub-title-en">Curtain Wall</div>
                                        <img src="" alt="">
                                    </router-link>
                                    <router-link tag="div" to="Case?index=2" class="item">
                                        <div class="sub-title">装饰装修</div>
                                        <div class="sub-title-en">Decoration</div>
                                        <img src="" alt="">
                                    </router-link>
                                    <!-- <router-link tag="div" to="" class="item">
                                        <div class="sub-title">智能门窗</div>
                                        <div class="sub-title-en">Smart Doors & Windows</div>
                                        <img src="" alt="">
                                    </router-link> -->
                                </div>
                            </div>
                        </div>
                        <div class="tip">用建筑科技守护生活！守护爱！</div>
                    </div>
                </div>
            </div>
            <div class="navbar-item">
                <span v-if="language == 'zh'">员工发展 Employee</span>
                <span v-else>Employee</span>
                <div class="menuList">
                    <div class="left">
                        <div class="zh">员工发展</div>
                        <div class="en">Employee</div>
                    </div>
                    <div class="right">
                        <router-link tag="div" to="/choeseTanjian" class="menu-item">
                            <div class="title">为什么选择探见？</div>
                            <div class="en">Why Choose TJI？</div>
                        </router-link>
                        <router-link tag="div" to="/workInTanjian" class="menu-item">
                            <div class="title">工作在探见</div>
                            <div class="en">Working At TJI</div>
                        </router-link>
                        <router-link tag="div" to="/JoinUs" class="menu-item">
                            <div class="title">加入我们</div>
                            <div class="en">Join Us</div>
                        </router-link>
                        <div class="tip">用建筑科技守护生活！守护爱！</div>
                    </div>
                </div>
            </div>
            <router-link tag="div" to="/news" class="navbar-item">
                <span v-if="language == 'zh'">新闻媒体 Media</span>
                <span v-else>Media</span>
            </router-link>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import search from './search'
import $ from 'jquery'
export default {
    name: '',
    components: {
        search
    },
    computed: {
        ...mapGetters({
            nav: 'getNav'
        }),
        language() {
            return this.$store.state.config.language
        },
    },
    data() {
        return {
            activeIndex: '/',
        }
    },
    watch: {
        $route: {
            handler(newRouter) {
                // console.log(newRouter)
                this.activeIndex = newRouter.path
                if (newRouter.path == '/NewsDetail') {
                    this.activeIndex = '/News'
                } else if (newRouter.path == '/CaseDetail') {
                    this.activeIndex = '/Case'
                } else if (newRouter.path == '/CoreBusinessDetail') {
                    this.activeIndex = '/CoreBusiness'
                }
                // console.log(newRouter)
            },
            immediate: true
        },
    },
    methods: {
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
.warp {
    width: 100%;
    height: 48px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    box-shadow: 0 5px 20px 2px rgba(0, 0, 0, 0.15);

    .logo {
        display: flex;
        align-items: center;
        width: 110px;
        // height: 28px;
        margin-left: 160px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .navbar {
        display: flex;
        margin-right: 160px;

        .navbar-item {

            span {
                font-size: 14px;
                font-weight: bold;
                text-align: center;
                cursor: pointer;
                margin: 0 20px;
                line-height: 48px;
            }


            &::after {
                // position: absolute;
                // bottom: 0;
                // left: 0;
                content: ' ';
                display: block;
                width: 0;
                height: 3px;
                margin-top: -3px;
                background-color: rgb(41, 48, 242);
                transition: all 0.5s;
                border-radius: 3px;
            }

            &:hover {
                &::after {
                    width: 100%;
                }

                .menuList {
                    // transform: translateY(0);
                    height: 300px;
                }
            }

            .menuList {
                position: absolute;
                left: 50%;
                top: 48px;
                transform: translateX(-50%);
                z-index: 10;
                background-color: #fff;
                width: calc(100% - 320px);
                overflow: hidden;
                display: flex;
                // transform: translateY(-120%);
                height: 0;
                transition: all 0.5s;
                box-shadow: 0 0px 2px 0px #efefef;
                border-radius: 2px;

                .left {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 30%;
                    height: 240px;
                    margin: 30px 0;
                    border-right: 1px solid rgb(195, 195, 196);

                    .zh {
                        font-size: 18px;
                        font-weight: bolder;
                        color: rgb(41, 48, 242);
                        text-align: center;
                    }

                    .en {
                        font-size: 18px;
                        color: rgb(195, 195, 196);
                        text-align: center;
                    }
                }

                .tip {
                    width: 100%;
                    text-align: right;
                    font-size: 10px;
                    color: rgb(172, 172, 172);
                    position: absolute;
                    bottom: 20px;
                    right: 50px;
                }

                .right {
                    width: calc(70% - 80px);
                    margin-left: 30px;
                    padding: 20px;
                    height: 240px;

                    .menu-item {
                        margin-bottom: 40px;
                        cursor: pointer;

                        .title {
                            text-align: left;
                            font-size: 16px;
                            color: rgb(95, 95, 95);
                            margin: 0;
                            font-weight: bolder;
                        }

                        .en {
                            margin: 0;
                            font-size: 12px;
                            color: rgb(172, 172, 172);
                        }
                    }


                }

                .aboutUs-right {
                    width: calc(70% - 80px);
                    margin-left: 30px;
                    padding: 20px;
                    height: 240px;

                    .tip {
                        width: 100%;
                        text-align: right;
                        font-size: 10px;
                        color: rgb(172, 172, 172);
                        position: absolute;
                        bottom: 20px;
                        right: 50px;
                    }

                    .aboutUs-right-warp {
                        display: flex;

                        .aboutUs-right-item {
                            width: 24%;

                            .title-warp {
                                cursor: pointer;

                                .title-zh {
                                    font-weight: bolder;
                                    text-align: left;
                                    margin: 0;
                                    font-size: 16px;
                                    color: rgb(95, 95, 95);
                                }

                                .title-en {
                                    text-align: left;
                                    margin: 0;
                                    font-size: 12px;
                                    color: rgb(172, 172, 172);
                                }
                            }

                            .sub-warp {
                                margin-top: 30px;
                                cursor: pointer;

                                .sub-title-zh {
                                    text-align: left;
                                    margin: 0;
                                    font-size: 12px;
                                    color: rgb(172, 172, 172);
                                }

                                .sub-title-en {
                                    text-align: left;
                                    margin: 0;
                                    font-size: 12px;
                                    color: rgb(172, 172, 172);
                                }
                            }
                        }
                    }
                }

                .anli-right {
                    width: calc(70% - 80px);
                    margin-left: 30px;
                    padding: 20px;
                    height: 240px;

                    .tip {
                        width: 100%;
                        text-align: right;
                        font-size: 10px;
                        color: rgb(172, 172, 172);
                        position: absolute;
                        bottom: 20px;
                        right: 50px;
                    }

                    .anli-right-warp {

                        .list-warp {
                            width: 100%;
                            margin-right: 30px;

                            .title-warp {
                                margin-bottom: 30px;

                                .title {
                                    font-weight: bolder;
                                    text-align: left;
                                    margin: 0;
                                    font-size: 16px;
                                    color: rgb(95, 95, 95);
                                }

                                .title-en {
                                    text-align: left;
                                    margin: 0;
                                    font-size: 12px;
                                    color: rgb(172, 172, 172);
                                }
                            }

                            .list-item {
                                display: flex;
                                margin-right: 30px;
                                margin-bottom: 30px;

                                .item {
                                    width: 200px;
                                    cursor: pointer;

                                    .sub-title {
                                        text-align: left;
                                        margin: 0;
                                        font-size: 12px;
                                        color: rgb(172, 172, 172);
                                    }

                                    .sub-title-en {
                                        text-align: left;
                                        margin: 0;
                                        font-size: 12px;
                                        color: rgb(172, 172, 172);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>